import { JFieldDTO } from "../../JFormCompositor";

export function fieldsTranslator<TypedJFieldDTO extends JFieldDTO>(fields: TypedJFieldDTO[], translate: (code: string, params: Record<string, unknown>) => string, params: Record<string, unknown>) {
    const _fields: TypedJFieldDTO[] = [...fields]

    for (let i = 0; i < _fields.length; i++) {
        const field = _fields[i];
        _fields[i] = fieldTranslator(field, translate, params)
    }

    return _fields
}
export function fieldTranslator<TypedJFieldDTO extends JFieldDTO>(field: TypedJFieldDTO, translate: (code: string, params: Record<string, unknown>) => string, params: Record<string, unknown>) {
    const _field: TypedJFieldDTO = JSON.parse(JSON.stringify(field))

    if (_field.cmsConfig.title) _field.cmsConfig.title = translate(_field.cmsConfig.title, params)
    if (_field.cmsConfig.text) _field.cmsConfig.text = translate(_field.cmsConfig.text, params)
    if (_field.cmsConfig.additionalText) _field.cmsConfig.additionalText = translate(_field.cmsConfig.additionalText, params)
    if (_field.cmsConfig.placeholder) _field.cmsConfig.placeholder = translate(_field.cmsConfig.placeholder, params)
    if (_field.cmsConfig.componentConfig.options.length) {
        for (const option of _field.cmsConfig.componentConfig.options) {
            if (option.label.title) option.label.title = translate(option.label.title, params)
            if (option.label.text) option.label.text = translate(option.label.text, params)
        }
    }
    if (_field.children?.length) {
        _field.children = fieldsTranslator(_field.children, translate, params)
    }

    return _field
}